import { useMemo, useRef, useState } from 'react'

import AccordionGrid from '@/components/sections/accordion-grid'
import Spacer from '@/components/sections/spacer'
import TabsHeading from '@/components/sections/tabs-heading'
import { useAppStore } from '@/contexts/store/use-store'
import { removeParagraph } from '@/utils'

import { WPFile } from '@/types/wp'

export type SupportoAssistenzaProps = {
  title?: string
  text?: string
  collection?: {
    title?: string
    content?: string
    doc_is_file?: boolean | null
    doc_link?: string
    doc_file?: WPFile
    doc_description?: string
    category?: {
      id: number
      name: string
      slug: string
    }[]
  }[]
  categories: {
    id: number
    name: string
    slug: string
  }[]
}

const SupportoAssistenza = ({ title, text, collection, categories }: SupportoAssistenzaProps) => {
  const { strings } = useAppStore()
  const tabs = useRef<any>(null)
  const [selectedTab, setSelectedTab] = useState(0)

  const filteredCollection = useMemo(() => {
    const selectedCategory = categories[selectedTab]
    return collection?.filter((item) =>
      item.category?.some((cat) => cat.slug === selectedCategory.slug)
    )
  }, [collection, selectedTab, categories])

  const allTabs = categories.map((cat) => ({ label: cat.name }))

  const handleTabChange = (index: number) => {
    setSelectedTab(index)
  }

  const accordionItems =
    filteredCollection?.map((item) => ({
      header: item.title || '',
      content: removeParagraph(item.doc_description) || '',
      actions: {
        read: item.doc_link
          ? {
              title: strings?.labels.read_more,
              url: item.doc_link,
              target: '_blank',
              classes: ''
            }
          : undefined,
        download:
          item.doc_is_file && item.doc_file
            ? {
                title: strings?.labels.download,
                url: item.doc_file?.url,
                target: '_blank',
                classes: ''
              }
            : undefined
      }
    })) || []

  return (
    <div>
      <TabsHeading
        ref={tabs}
        title={title}
        text={text}
        tabs={allTabs}
        onTabChange={handleTabChange}
        is_first={true}
      />
      <Spacer size="sm" />
      <AccordionGrid items={accordionItems} />
    </div>
  )
}

export default SupportoAssistenza
